import script from "./rebindPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./rebindPhone.vue?vue&type=script&setup=true&lang=js"

import "./rebindPhone.vue?vue&type=style&index=0&id=319a29ce&lang=scss&scoped=true"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319a29ce"]])

export default __exports__